import React from 'react';
import { AnnotationPanelWrap, PanelHeader, IconGrid, IconCell } from './Annotation.styles';

const DRAWING_TOOLS = [
  {
    key: 'route',
    label: 'Route Line',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
        <path d="M5 19 C5 19 7 5 12 5 C17 5 19 19 19 19" strokeDasharray="3 2"/>
        <polygon points="19,14 21,19 17,19" fill="currentColor" stroke="none"/>
      </svg>
    ),
  },
  {
    key: 'zone',
    label: 'Zone Area',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="#16A34A" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="4" width="16" height="16" rx="1"/>
      </svg>
    ),
  },
  {
    key: 'text',
    label: 'Text Label',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
        <path d="M4 7V4h16v3"/>
        <path d="M9 20h6"/>
        <path d="M12 4v16"/>
      </svg>
    ),
  },
  {
    key: 'eraser',
    label: 'Eraser',
    svg: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 20H7L3 16l10-10 7 7-3.5 3.5"/>
        <path d="M6.5 17.5l4-4"/>
      </svg>
    ),
  },
];

const DrawingToolsPanel = ({ activeTool, onSelectTool, onClose }) => {
  return (
    <AnnotationPanelWrap>
      <PanelHeader>
        <span>Drawing Tools</span>
        <button onClick={onClose}>×</button>
      </PanelHeader>
      <IconGrid style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
        {DRAWING_TOOLS.map(tool => (
          <IconCell
            key={tool.key}
            active={activeTool === tool.key}
            onClick={() => onSelectTool(tool.key)}
          >
            {tool.svg}
            <span>{tool.label}</span>
          </IconCell>
        ))}
      </IconGrid>
    </AnnotationPanelWrap>
  );
};

export default DrawingToolsPanel;
